import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { GenericRequest } from '../../models/ciudad/generic-request';
import { GeneralResponse } from '../../models/ciudad/generic-response';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root',
})
export class ServiceGetAfiliado {
  // private apiUrl = environment.EXTERNAL.serviceAfiliado;
  private apiUrl = `${environment.HOST}${URL_MAP.EXTERNAL.serviceAfiliado}`;
  private apiUrl2 = `${environment.HOST}${URL_MAP.EXTERNAL.GET_CREDENCIAL}`;

  constructor(private http: HttpClient) {}

  getAfiliadoCore(
    endpoint: string,
    tipo_id: string,
    id: string,
  ): Observable<GeneralResponse<any>> {
    const body: GenericRequest = {
      nombreClave: 'getAfiliadoCore',
      jsonParametros: JSON.stringify({ tipo_id, id }),
    };

    const url = `${this.apiUrl}/${endpoint}`;
    return this.http.post<GeneralResponse<any>>(url, body);
  }

  getCartillaDetalle(endpoint: string, numCartilla: string): Observable<any> {
    const payload = {
          nombreClave: 'getciucorserv',
          jsonParametros: JSON.stringify({
            prm_codcarti: numCartilla,
          }),
        };
        const url = `${this.apiUrl}/${endpoint}`;    
    return this.http.post<GeneralResponse<any>>(url, payload);
  }

  getCredencial(
    endpoint: string,
    tipo_id: string,
    id: string
  ): Observable<GeneralResponse<any>> {
    const payload = {
      nombreClave: 'getAfiliadoCore',
      jsonParametros: JSON.stringify({ tipo_id, id }),
    };

    const url = `${this.apiUrl2}/${endpoint}`;
    return this.http.post<GeneralResponse<any>>(url, payload);
  }
}